module.exports = __webpack_public_path__ + "static/media/profile-screen-bg.197bf030.png";